import type { TruckTypeListType } from "@/api/trucks/dto/truck.dto";
import i18n from "@/plugins/i18n";

export const TruckDoorType = [
  { id: "s", name: "Swing" },
  { id: "r", name: "Roll" },
];

export const TruckEquipment = [
  { id: "ar", name: "Air Ride" },
  { id: "lg", name: "Lift Gate" },
  { id: "icc_bar", name: "ICC Bar" },
  { id: "vet", name: "Vertical E-Track" },
  { id: "het", name: "Horizontal E-Track" },
];

export const TruckAdditionalEquipment = [
  { id: "pj", name: "Pallet Jack" },
  { id: "ppe", name: "PPE" },
  { id: "straps", name: "Straps" },
  { id: "lg", name: "Landing Gears" },
  { id: "dhr", name: "Dock Height Wheel Risers (Plastic)" },
  { id: "dhm", name: "Dock Height Wheel Risers (Metal)" },
  { id: "ramps", name: "Portable Loading Ramps" },
  { id: "lb", name: "Load Bar" },
];

export const TruckTypeList: TruckTypeListType[] = [
  { id: "sts", name: "Semi truck (Sleeper)", hasTrailer: false },
  { id: "std", name: "Semi truck (Day cab)", hasTrailer: false },
  { id: "cv", name: "Cargo Van", hasTrailer: true },
  { id: "sv", name: "Sprinter Van", hasTrailer: true },
  { id: "bt", name: "Box Truck", hasTrailer: true },
  { id: "st", name: "Straight Truck", hasTrailer: true },
  { id: "cs", name: "Curtain side", hasTrailer: true },
  { id: "rsv", name: "Sprinter van reefer", hasTrailer: true },
  { id: "rbt", name: "Box truck reefer", hasTrailer: true },
  { id: "rcv", name: "Cargo van reefer", hasTrailer: true },
  { id: "rst", name: "Straight truck reefer", hasTrailer: true },
];

export const TrailerType = [
  { id: "dv", name: "Dry van" },
  { id: "r", name: "Reefer" },
  { id: "sd", name: "Step deck" },
  { id: "f", name: "Flatbed" },
];

export enum TruckViewTab {
  general = "general",
  activeRoutes = "activeRoutes",
  completedRoutes = "completedRoutes",
  reservations = "reservations",
}

export const TRUCK_RESERVATIONS_PAGE_SIZE = 25;

export const TRUCK_RESERVATIONS_DIALOG_PAGE_SIZE = 5;

export const TRUCK_RESERVATION_MINUTES = [5, 10, 15, 20, 30, 45, 60];

export const RESERVATION_HISTORY_PANEL = "reservation-history";

export const TruckViewTabHash: Record<TruckViewTab, string> = {
  [TruckViewTab.general]: "",
  [TruckViewTab.activeRoutes]: "active-routes",
  [TruckViewTab.completedRoutes]: "completed-routes",
  [TruckViewTab.reservations]: "reservations",
};

export enum TruckStatus {
  Available = "a",
  WillBeAvailable = "w",
  OnHold = "h",
  InRoute = "r",
  NotAvailable = "n",
}

export const TruckStatusList = [
  {
    id: TruckStatus.NotAvailable,
    name: i18n.global.t("trucks.status-n"),
    forTrip: true,
  },
  {
    id: TruckStatus.OnHold,
    name: i18n.global.t("trucks.status-h"),
  },
  {
    id: TruckStatus.Available,
    name: i18n.global.t("trucks.status-a"),
    disabled: true,
    forTrip: true,
  },
  {
    id: TruckStatus.WillBeAvailable,
    name: i18n.global.t("trucks.status-w"),
    disabled: true,
  },
  {
    id: TruckStatus.InRoute,
    name: i18n.global.t("trucks.status-r"),
    disabled: true,
  },
];

export const TruckStatusNames: Record<TruckStatus, string> = {
  [TruckStatus.NotAvailable]: i18n.global.t("trucks.status-n"),
  [TruckStatus.OnHold]: i18n.global.t("trucks.status-h"),
  [TruckStatus.Available]: i18n.global.t("trucks.status-a"),
  [TruckStatus.WillBeAvailable]: i18n.global.t("trucks.status-w"),
  [TruckStatus.InRoute]: i18n.global.t("trucks.status-r"),
};
